import styled from '@emotion/styled';
import { Button } from '../../shared/Button/NewButton';
import { Modal } from '../../shared/Modal';
import { MD_SCREEN_MIN } from '../../modules/Styleguide';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .labelWrapper {
    margin-bottom: 10px;
  }
`;

export const PseudoLabel = styled.span`
  color: #292f36;
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 2rem;
  margin-bottom: 10px;
`;

export const DropdownWrapper = styled.div`
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
  }
`;

export const Dropdown = styled.div`
  height: 46px;
  width: 210px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 6px;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
  }
  background-color: #dfe0e1;
  &:hover {
    background-color: #d4d5d7;
  }
  &:active {
    background-color: #c9cbcd;
  }
`;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    width: 500px;
    @media (max-width: ${MD_SCREEN_MIN}) {
      width: 100%;
      margin: 0 !important;
    }
  }
  .modal-content {
    margin: 0;
    @media (max-width: ${MD_SCREEN_MIN}) {
      border-radius: 0;
      height: 100%;
    }
  }
`;

export const ModalContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 378px;
  margin: 0 auto;
`;

export const PublishDateDisplay = styled.p`
  color: #5f6369;
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: bold;
`;

export const CalendarLabel = styled.label`
  width: 100%;
  text-align: center;
  font-size: 22px;
  margin-bottom: 24px;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

export const ButtonSectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 14px;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    flex-direction: column-reverse;
  }
`;

export const StyledButton = styled(Button)`
  width: 174px;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
    margin-bottom: 14px;
  }
`;

export const LocalTimezoneMessage = styled.p`
  color: #7f8287;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
`;
